// import { relogin } from 'api/auth';
import { type ReactElement, useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import {
  // userIdState,
  tokenState,
  isLoggedInSelector,
  // useSetAuthState,
  useResetAuthState,
} from './state';

type Props = {
  children: ReactElement;
  loading: ReactElement;
};

const PersistAuthGate = ({ children, loading }: Props) => {
  // const setAuthState = useSetAuthState();
  const resetAuthState = useResetAuthState();

  // const username = useRecoilValue(userIdState);
  const token = useRecoilValue(tokenState);
  const isLoggedIn = useRecoilValue(isLoggedInSelector);

  useEffect(() => {
    const doRelogin = async () => {
      resetAuthState();
    };

    if (token) {
      doRelogin();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (token && !isLoggedIn) {
    return loading;
  }

  return children;
};

export default PersistAuthGate;
